import { analyticsEcommerceVendorClick } from "../../helpers/analytics";
import { isExternalLink } from "../../helpers/isExternalLink";
import { notNullish } from "../../helpers/notNullish";
import { ButtonPcs } from "../ButtonPcs/ButtonPcs";
import { SelectButton } from "../SelectButton/SelectButton";
import { CosmosButtonProps } from "@cosmos/web-react";
import { ComponentProps } from "react";

interface links {
  url: string | null;
  label: string | null;
  icon: string | null;
}

export const BuyNowVendorLinks = ({
  id,
  label,
  className,
  buttonSize = "medium",
  buttonAppearance = "dark",
  links,
  analyticsElementPosition = "VendorLink",
  buttonCustomColor,
  listboxPosition,
}: {
  id: string;
  label: string;
  className: string;
  buttonSize: CosmosButtonProps["size"];
  buttonAppearance?: CosmosButtonProps["appearance"];
  links: links[];
  analyticsElementPosition: string;
  buttonCustomColor?: ComponentProps<typeof ButtonPcs>["customColor"];
  listboxPosition?: "top" | "bottom";
}) => {
  return (
    <SelectButton
      id={id}
      buttonClassName={className}
      buttonSize={buttonSize}
      buttonAppearance={buttonAppearance}
      buttonCustomColor={buttonCustomColor ?? undefined}
      listboxPosition={listboxPosition}
      label={label ?? ""}
      items={
        links.filter(notNullish).map((item) => ({
          label: item?.label ?? "",
          url: item?.url ?? "",
          icon: item?.icon ?? undefined,
          onClick: () =>
            analyticsEcommerceVendorClick({
              value: item?.label,
              clickUrl: item?.url,
              elementPosition: analyticsElementPosition,
              method: isExternalLink(item?.url ?? "")
                ? "Outbound: TRUE"
                : "Outbound: FALSE",
              contentType: "Button Click, Buy now",
            }),
        })) ?? []
      }
    />
  );
};
